import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Collapse,
  Form,
  Input,
  Modal,
  message,
  Radio,
  Row,
  Switch,
  Typography,
} from 'antd';
import React from 'react';
import { FaXTwitter } from 'react-icons/fa6';
import {
  IoCheckmarkDoneSharp,
  IoLinkOutline,
  IoLogoFacebook,
  IoLogoGoogle,
  IoLogoInstagram,
  IoLogoLinkedin,
  IoLogoWhatsapp,
  IoLogoYoutube,
} from 'react-icons/io5';
import ReactInputMask from 'react-input-mask';
import { Link, Navigate } from 'react-router-dom';
import { getToken, POST_API, POST_CATCH } from '../../services/api';
import ControllerPageLoad from '../Controller/PageLoad';

class WebRegister extends React.Component {
  state = {
    _navigate: false,
    _loading: false,
    _screen: false,
    _params: window.location.href.split('/'),
    defaultValue: null,
    doc: true,
    login: false,
    planos: [],
    payment: false,
    planos_load: true,
    plano_selecionado: null,
    plano_selecionado_data: null,
    account_id: null,
    modalVisible: false,
    type_plan: null,
  };

  breadcrumb = [
    {
      title: (
        <Link to="/">
          <Typography className="home-breadcrumb-link">Home</Typography>
        </Link>
      ),
    },
    {
      title: (
        <Typography className="home-breadcrumb-link active">
          Cadastre-se
        </Typography>
      ),
    },
  ];

  onSend = () => {
    this.setState({ _loading: true });
    if (
      this.state.defaultValue.PASSWORD !==
      this.state.defaultValue.CONFIRM_PASSWORD
    ) {
      message.warning({ content: 'As senhas não conferem', key: 'screen' });
      this.setState({ _loading: false });
      return;
    }
    if (!(this.state.plano_selecionado > 0)) {
      message.warning({ content: 'Selecione um plano', key: 'screen' });
      this.setState({ _loading: false });
      return;
    }
    POST_API('/office/register.php', {
      token: getToken(),
      type: this.props.type,
      master: JSON.stringify({
        ...this.state.defaultValue,
        PLAN_ID: this.state.plano_selecionado,
      }),
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          this.setState({
            account_id: res.account,
            modalVisible: true,
          });
        } else {
          message.warning({ content: res.msg, key: 'screen' });
        }
      })
      .catch(() => POST_CATCH())
      .finally(() => this.setState({ _loading: false }));
  };

  buscaCEP = async (val) => {
    const cep = String(val.target.value).replace('-', '');
    this.setState({ _screen: true });
    await fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((rs) => rs.json())
      .then((res) => {
        if (res.erro) {
          message.warning('CEP inválido');
        } else {
          this.setState({
            defaultValue: {
              ...this.state.defaultValue,
              STREET: res.logradouro,
              DISTRICT: res.bairro,
              CITY: res.localidade,
              STATE: res.uf,
            },
          });
        }
      })
      .catch(() => {
        message.warning(
          'Não foi possível estabelecer uma conexão com o sistema'
        );
      })
      .finally(() => this.setState({ _screen: false }));
  };

  onChangeField = (a) => {
    const name = a[0].name[0];
    const value = a[0].value;
    this.setState({
      defaultValue: {
        ...this.state.defaultValue,
        [name]: value,
      },
    });
  };

  onSearchPlan = () => {
    this.setState({ planos_load: true });
    POST_API('/plan/search.php', { token: getToken(), type: 'list' })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          this.setState({ planos: res.data });
        } else {
          message.warning({ content: res.msg, key: 'screen' });
        }
      })
      .catch(() => POST_CATCH())
      .finally(() => this.setState({ planos_load: false }));
  };

  onSendPayment = (values) => {
    if (!this.state.type_plan) {
      message.warning({
        content: 'Selecione um tipo de assinatura',
        key: 'screen',
      });
      this.setState({ _loading: false });
      return;
    }
    this.setState({ _loading: true });
    POST_API('/subscription/asaas.php', {
      token: 'X',
      account: this.state.account_id,
      master: JSON.stringify(values),
      PLAN_ID: this.state.plano_selecionado,
      type: this.state.type_plan,
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          message.success({ content: res.msg, key: 'screen' });
          this.setState({ payment: true });
        } else {
          message.warning({ content: res.msg, key: 'screen' });
        }
      })
      .catch(() => {
        POST_CATCH();
      })
      .finally(() => this.setState({ _loading: false }));
  };

  componentDidMount = () => {
    this.onSearchPlan();
  };

  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: ignorar
  render = () => {
    if (this.state.login) {
      return <Navigate to="/login" />;
    }

    return (
      <Row>
        <Col className="home-col-black" span={24}>
          <Row align={'middle'} className="home-row-breadcrumb">
            <Col span={12}>
              <Breadcrumb className="home-breadcrumb" items={this.breadcrumb} />
            </Col>
            <Col span={12}>
              <Typography className="home-breadcrumb-title">
                Cadastre-se
              </Typography>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row className="home-row-page" gutter={[60, 16]}>
            <Col span={24}>
              <Typography className="home-row-page-text-title">
                Cadastre-se
              </Typography>
            </Col>

            <Col span={24}>
              <Typography className="about-row-title">
                SOU ADVOGADO / ESCRITÓRIO
              </Typography>
            </Col>
            <Col span={24}>
              <Typography
                className="about-row-subtitle"
                style={{ marginTop: -16 }}
              >
                Escolha o plano:
              </Typography>
              <Radio.Group
                onChange={(e) =>
                  this.setState({ plano_selecionado: e.target.value })
                }
                value={this.state.plano_selecionado}
              >
                <Row align={'top'} gutter={[8, 8]}>
                  {this.state.planos_load ? (
                    <Col span={24}>
                      <ControllerPageLoad />
                    </Col>
                  ) : (
                    this.state.planos.map((item, index) =>
                      item.ID === '1' ? (
                        <Col key={item.ID} md={24} xs={24}>
                          {/** biome-ignore lint/a11y/noStaticElementInteractions: div */}
                          {/** biome-ignore lint/a11y/useKeyWithClickEvents: div */}
                          {/** biome-ignore lint/nursery/noNoninteractiveElementInteractions: div */}
                          <div
                            className="home-col-out-red plan-card-3"
                            onClick={() =>
                              this.setState({
                                plano_selecionado: item.ID,
                                plano_selecionado_data: item,
                              })
                            }
                            style={{ cursor: 'pointer' }}
                          >
                            <Radio
                              size="large"
                              style={{
                                position: 'absolute',
                                top: 10,
                                left: 14,
                              }}
                              value={item.ID}
                            />
                            <Row>
                              <Col className="plan-div" md={12} xs={24}>
                                <Typography className="plan-title">
                                  PLANO <span>GRÁTIS</span>
                                </Typography>
                                <Typography className="plan-subtitle">
                                  “e sempre será!”
                                </Typography>
                              </Col>
                              <Col md={12} xs={24}>
                                <Typography
                                  className="about-row-subtitle"
                                  style={{ marginBottom: '0px' }}
                                >
                                  <span
                                    style={{ paddingTop: 2, marginRight: 2 }}
                                  >
                                    <IoCheckmarkDoneSharp
                                      color="var(--primary)"
                                      size={18}
                                    />
                                  </span>
                                  Acesso para {this.state.data?.[0]?.gratis}{' '}
                                  usuário.
                                </Typography>
                                <Typography
                                  className="about-row-subtitle"
                                  style={{ marginBottom: '0px' }}
                                >
                                  <span
                                    style={{ paddingTop: 2, marginRight: 2 }}
                                  >
                                    <IoCheckmarkDoneSharp
                                      color="var(--primary)"
                                      size={18}
                                    />
                                  </span>
                                  Até {this.state.data?.[2]?.gratis} processos
                                  cadastrados.
                                </Typography>
                                <Typography
                                  className="about-row-subtitle"
                                  style={{ marginBottom: '0px' }}
                                >
                                  <span
                                    style={{ paddingTop: 2, marginRight: 2 }}
                                  >
                                    <IoCheckmarkDoneSharp
                                      color="var(--primary)"
                                      size={18}
                                    />
                                  </span>
                                  Histórico ações por processos.
                                </Typography>
                                <Typography
                                  className="about-row-subtitle"
                                  style={{ marginBottom: '0px' }}
                                >
                                  <span
                                    style={{ paddingTop: 2, marginRight: 2 }}
                                  >
                                    <IoCheckmarkDoneSharp
                                      color="var(--primary)"
                                      size={18}
                                    />
                                  </span>
                                  Histórico ações por clientes.
                                </Typography>
                                <Typography
                                  className="about-row-subtitle"
                                  style={{ marginBottom: '0px' }}
                                >
                                  <span
                                    style={{ paddingTop: 2, marginRight: 2 }}
                                  >
                                    <IoCheckmarkDoneSharp
                                      color="var(--primary)"
                                      size={18}
                                    />
                                  </span>
                                  E-mail automático para clientes.
                                </Typography>
                                <Typography
                                  className="about-row-subtitle"
                                  style={{ marginBottom: '0px' }}
                                >
                                  <span
                                    style={{ paddingTop: 2, marginRight: 2 }}
                                  >
                                    <IoCheckmarkDoneSharp
                                      color="var(--primary)"
                                      size={18}
                                    />
                                  </span>
                                  Controle de tarefas, prazos, audiências
                                  (Workflow).
                                </Typography>
                                <Typography
                                  className="about-row-subtitle"
                                  style={{ marginBottom: '0px' }}
                                >
                                  <span
                                    style={{ paddingTop: 2, marginRight: 2 }}
                                  >
                                    <IoCheckmarkDoneSharp
                                      color="var(--primary)"
                                      size={18}
                                    />
                                  </span>
                                  Controle financeiro.
                                </Typography>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      ) : (
                        <Col key={item.ID} md={6} xs={24}>
                          {/** biome-ignore lint/a11y/noStaticElementInteractions: div */}
                          {/** biome-ignore lint/a11y/useKeyWithClickEvents: div */}
                          {/** biome-ignore lint/nursery/noNoninteractiveElementInteractions: div */}
                          <div
                            className={`${index % 2 !== 0 ? 'home-col-black' : 'home-col-red'} plan-card-2 `}
                            onClick={() =>
                              this.setState({
                                plano_selecionado: item.ID,
                                plano_selecionado_data: item,
                              })
                            }
                            style={{ cursor: 'pointer', height: '300px' }}
                          >
                            <Radio
                              size="large"
                              style={{
                                position: 'absolute',
                                top: 10,
                                left: 14,
                              }}
                              value={item.ID}
                            />
                            <Typography className="plan-card-title">
                              {item.NAME}
                            </Typography>
                            <Typography className="plan-card-text">
                              {item.DESC}
                            </Typography>
                            <Typography className="plan-card-price">
                              {item.PRICE_MONTH_FORMAT}
                              <span> / MÊS</span>
                            </Typography>
                            <Typography className="plan-card-text">
                              Ou
                            </Typography>
                            <Typography className="plan-card-price">
                              {item.PRICE_YEAR_FORMAT}
                              <span> / ANO</span>
                            </Typography>
                          </div>
                        </Col>
                      )
                    )
                  )}
                </Row>
              </Radio.Group>
            </Col>
            <Col span={24} style={{ marginTop: 16 }}>
              <Typography
                className="about-row-subtitle"
                style={{ marginTop: -16 }}
              >
                Preencha os dados abaixo para criar sua conta.
              </Typography>
              {this.state._screen ? (
                <ControllerPageLoad />
              ) : (
                <Card>
                  <Form
                    initialValues={this.state.defaultValue}
                    layout="vertical"
                    onFieldsChange={(a, b) => this.onChangeField(a, b)}
                    onFinish={this.onSend}
                  >
                    <Form.Item hidden name="ID">
                      <Input />
                    </Form.Item>
                    <Row gutter={[16, 0]}>
                      <Col md={6} xs={24}>
                        <Form.Item
                          label={this.state.doc ? 'CNPJ' : 'CPF'}
                          name="LOGIN"
                          rules={[
                            { required: true, message: 'Campo obrigatório*' },
                          ]}
                        >
                          <ReactInputMask
                            mask={
                              this.state.doc
                                ? '99.999.999/9999-99'
                                : '999.999.999-99'
                            }
                            maskChar={''}
                            maxLength={this.state.doc ? 18 : 14}
                            placeholder={this.state.doc ? 'CNPJ' : 'CPF'}
                          >
                            {(props) => <Input {...props} />}
                          </ReactInputMask>
                        </Form.Item>
                        <Switch
                          checked={this.state.doc}
                          checkedChildren="CNPJ"
                          onChange={(v) => this.setState({ doc: v })}
                          style={{ position: 'absolute', right: 13, top: 35 }}
                          unCheckedChildren="CPF"
                        />
                      </Col>
                      <Col md={10} xs={24}>
                        <Form.Item
                          label="Nome"
                          name="NAME"
                          rules={[
                            { required: true, message: 'Campo obrigatório*' },
                          ]}
                        >
                          <Input type="text" />
                        </Form.Item>
                      </Col>
                      <Col md={4} xs={24}>
                        <Form.Item
                          label="Senha"
                          name="PASSWORD"
                          rules={[
                            { required: true, message: 'Campo obrigatório*' },
                          ]}
                        >
                          <Input type="password" />
                        </Form.Item>
                      </Col>
                      <Col md={4} xs={24}>
                        <Form.Item
                          label="Confirmar senha"
                          name="CONFIRM_PASSWORD"
                          rules={[
                            { required: true, message: 'Campo obrigatório*' },
                          ]}
                        >
                          <Input type="password" />
                        </Form.Item>
                      </Col>
                      <Col md={6} xs={24}>
                        <Form.Item
                          label="E-mail"
                          name="EMAIL"
                          rules={[
                            { required: true, message: 'Campo obrigatório*' },
                          ]}
                        >
                          <Input addonBefore={<IoLogoGoogle />} type="email" />
                        </Form.Item>
                      </Col>
                      <Col md={6} xs={24}>
                        <Form.Item label="Whatsapp" name="WHATSAPP">
                          <ReactInputMask
                            mask={'(99) 99999-9999'}
                            maskChar={''}
                            maxLength={15}
                            value={this.state.defaultValue?.WHATSAPP}
                          >
                            {(props) => (
                              <Input
                                {...props}
                                addonAfter={<IoLogoWhatsapp />}
                              />
                            )}
                          </ReactInputMask>
                        </Form.Item>
                      </Col>
                      <Col md={6} xs={24}>
                        <Form.Item label="Instagram" name="INSTAGRAM">
                          <Input
                            addonBefore={<IoLogoInstagram />}
                            type="text"
                          />
                        </Form.Item>
                      </Col>
                      <Col md={6} xs={24}>
                        <Form.Item label="Facebook" name="FACEBOOK">
                          <Input addonBefore={<IoLogoFacebook />} type="text" />
                        </Form.Item>
                      </Col>
                      <Col md={6} xs={24}>
                        <Form.Item label="X" name="TWITTER">
                          <Input addonBefore={<FaXTwitter />} type="text" />
                        </Form.Item>
                      </Col>
                      <Col md={6} xs={24}>
                        <Form.Item label="LinkedIn" name="LINKEDIN">
                          <Input addonBefore={<IoLogoLinkedin />} type="text" />
                        </Form.Item>
                      </Col>
                      <Col md={6} xs={24}>
                        <Form.Item label="Youtube" name="YOUTUBE">
                          <Input addonBefore={<IoLogoYoutube />} type="text" />
                        </Form.Item>
                      </Col>
                      <Col md={6} xs={24}>
                        <Form.Item label="Site" name="SITE">
                          <Input addonBefore={<IoLinkOutline />} type="text" />
                        </Form.Item>
                      </Col>
                      <Col md={3} xs={24}>
                        <Form.Item label="CEP" name="CEP">
                          <ReactInputMask
                            mask={'99999-999'}
                            maskChar={''}
                            maxLength={9}
                            onBlur={this.buscaCEP}
                          >
                            {(props) => <Input {...props} />}
                          </ReactInputMask>
                        </Form.Item>
                      </Col>
                      <Col md={8} xs={24}>
                        <Form.Item label="Endereço" name="STREET">
                          <Input type="text" />
                        </Form.Item>
                      </Col>
                      <Col md={3} xs={24}>
                        <Form.Item label="Número" name="NUMBER">
                          <Input type="text" />
                        </Form.Item>
                      </Col>
                      <Col md={4} xs={24}>
                        <Form.Item label="Bairro" name="DISTRICT">
                          <Input type="text" />
                        </Form.Item>
                      </Col>
                      <Col md={4} xs={24}>
                        <Form.Item label="Cidade" name="CITY">
                          <Input type="text" />
                        </Form.Item>
                      </Col>
                      <Col md={2} xs={24}>
                        <Form.Item label="UF" name="STATE">
                          <Input maxLength={2} type="text" />
                        </Form.Item>
                      </Col>
                      <Col md={24} xs={24}>
                        <Button
                          className="float-right"
                          htmlType="submit"
                          loading={this.state._loading}
                          shape="round"
                          type="primary"
                        >
                          {this.state.plano_selecionado > 1
                            ? 'Ir para o pagamento'
                            : 'Criar conta'}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Card>
              )}
            </Col>

            <Col span={24}>
              <Typography className="about-row-title">SOU CLIENTE</Typography>
            </Col>
            <Col span={24}>
              <Typography
                className="about-row-subtitle"
                style={{ marginTop: -16 }}
              >
                Para obter seu perfil de cliente, um escritório ou advogado
                registrado na JurisVip precisa fazer seu cadastro.
              </Typography>
            </Col>
          </Row>
        </Col>
        <Modal
          closable={false}
          footer={null}
          onCancel={() => null}
          open={this.state.modalVisible}
          style={{ top: 10 }}
          width={800}
        >
          <Row gutter={[8, 8]}>
            <Col span={24}>
              <Typography className="home-row-page-text-title">
                Sua conta foi criada com sucesso!
              </Typography>
              <Typography className="about-row-subtitle">
                Enviamos um e-mail de confirmação para o seu endereço de e-mail.
              </Typography>
              {this.state.plano_selecionado > 1 ? (
                this.state.payment ? (
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <Typography
                        className="about-row-title"
                        style={{ marginTop: 20 }}
                      >
                        Assinatura do plano concluída
                      </Typography>
                      <Typography className="about-row-subtitle">
                        Já pode realizar o login e aproveitar nossos serviços
                      </Typography>
                    </Col>
                    <Col span={24}>
                      <Row
                        gutter={[8, 8]}
                        justify={'end'}
                        style={{ marginTop: 20 }}
                      >
                        <Col>
                          <Button
                            onClick={() =>
                              this.setState({ modalVisible: false })
                            }
                            size="large"
                          >
                            Fechar
                          </Button>
                        </Col>
                        <Col>
                          <Button
                            onClick={() => this.setState({ login: true })}
                            size="large"
                            type="primary"
                          >
                            Ir para a tela de login
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ) : (
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <Typography
                        className="about-row-title"
                        style={{ marginTop: 20 }}
                      >
                        Finalizar assinatura do plano
                      </Typography>
                    </Col>
                    <Col span={24}>
                      <Row
                        align={'bottom'}
                        gutter={[8, 8]}
                        style={{
                          border: '1px solid var(--primary)',
                          borderRadius: 4,
                          padding: 10,
                        }}
                      >
                        <Col span={24}>
                          <Typography className="text-new">
                            {this.state.plano_selecionado_data?.NAME}
                          </Typography>
                          <Typography className="text-new-sub">
                            {this.state.plano_selecionado_data?.DESC}
                          </Typography>
                        </Col>
                        <Col span={24}>
                          <Radio.Group
                            onChange={(value) =>
                              this.setState({ type_plan: value.target.value })
                            }
                            value={this.state.type_plan}
                          >
                            <Row>
                              <Col span={24}>
                                <Radio value="M">
                                  <Typography style={{ fontSize: 18 }}>
                                    Assinatura mensal -{' '}
                                    <span style={{ fontWeight: 'bold' }}>
                                      {
                                        this.state.plano_selecionado_data
                                          ?.PRICE_MONTH_FORMAT
                                      }{' '}
                                      / mês
                                    </span>
                                  </Typography>
                                </Radio>
                              </Col>
                              <Col span={24}>
                                <Radio value="A">
                                  <Typography style={{ fontSize: 18 }}>
                                    Assinatura anual -{' '}
                                    <span style={{ fontWeight: 'bold' }}>
                                      {
                                        this.state.plano_selecionado_data
                                          ?.PRICE_YEAR_FORMAT
                                      }{' '}
                                      / ano
                                    </span>
                                  </Typography>
                                </Radio>
                              </Col>
                            </Row>
                          </Radio.Group>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Typography
                        className="about-row-title"
                        style={{ marginTop: 20 }}
                      >
                        Escolha uma forma de pagamento
                      </Typography>
                      <Collapse accordion={true}>
                        <Collapse.Panel header="Cartão de crédito" key={0}>
                          <Form onFinish={this.onSendPayment}>
                            <Row gutter={[8, 0]}>
                              <Form.Item
                                hidden
                                initialValue="CREDIT_CARD"
                                name="TYPE"
                              >
                                <Input value="CREDIT_CARD" />
                              </Form.Item>
                              <Col span={24}>
                                <Form.Item
                                  name={'NUMBER'}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Campo obrigatório',
                                    },
                                  ]}
                                >
                                  <ReactInputMask
                                    mask={'9999 9999 9999 9999'}
                                    maskChar={''}
                                    maxLength={19}
                                    placeholder={'Número do cartão'}
                                  >
                                    {(props) => <Input {...props} />}
                                  </ReactInputMask>
                                </Form.Item>
                              </Col>
                              <Col span={24}>
                                <Form.Item
                                  name={'NAME'}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Campo obrigatório',
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={'Nome do titular'}
                                    size="large"
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={14}>
                                <Form.Item
                                  name={'EXPIRY'}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Campo obrigatório',
                                    },
                                  ]}
                                >
                                  <ReactInputMask
                                    mask={'99/99'}
                                    maskChar={''}
                                    maxLength={5}
                                    placeholder={'Validade'}
                                  >
                                    {(props) => <Input {...props} />}
                                  </ReactInputMask>
                                </Form.Item>
                              </Col>
                              <Col span={10}>
                                <Form.Item
                                  name={'CVC'}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Campo obrigatório',
                                    },
                                  ]}
                                >
                                  <ReactInputMask
                                    mask={'999'}
                                    maskChar={''}
                                    maxLength={3}
                                    placeholder={'CVC'}
                                  >
                                    {(props) => <Input {...props} />}
                                  </ReactInputMask>
                                </Form.Item>
                              </Col>
                              <Col span={24}>
                                <Button
                                  block
                                  htmlType="submit"
                                  loading={this.state._loading}
                                  type="primary"
                                >
                                  Finalizar
                                </Button>
                              </Col>
                            </Row>
                          </Form>
                        </Collapse.Panel>
                        {/* <Collapse.Panel header="Pix" key={1}>
                          <Form onFinish={this.onSendPayment}>
                            <Row gutter={[8, 0]}>
                              <Form.Item hidden initialValue="PIX" name="TYPE">
                                <Input value="PIX" />
                              </Form.Item>
                              <Col span={24}>
                                <Button
                                  block
                                  htmlType="submit"
                                  loading={this.state._loading}
                                  type="primary"
                                >
                                  Gerar pix
                                </Button>
                              </Col>
                            </Row>
                          </Form>
                        </Collapse.Panel>
                        <Collapse.Panel header="Boleto" key={2}>
                          <Form onFinish={this.onSendPayment}>
                            <Row gutter={[8, 0]}>
                              <Form.Item
                                hidden
                                initialValue="BOLETO"
                                name="TYPE"
                              >
                                <Input value="BOLETO" />
                              </Form.Item>
                              <Col span={24}>
                                <Button
                                  block
                                  htmlType="submit"
                                  loading={this.state._loading}
                                  type="primary"
                                >
                                  Gerar boleto
                                </Button>
                              </Col>
                            </Row>
                          </Form>
                        </Collapse.Panel> */}
                      </Collapse>
                    </Col>
                  </Row>
                )
              ) : (
                <Row gutter={[8, 8]} justify={'end'} style={{ marginTop: 20 }}>
                  <Col>
                    <Button
                      onClick={() => this.setState({ modalVisible: false })}
                      size="large"
                    >
                      Fechar
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      onClick={() => this.setState({ login: true })}
                      size="large"
                      type="primary"
                    >
                      Ir para a tela de login
                    </Button>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Modal>
      </Row>
    );
  };
}

export default WebRegister;
